"use strict"

/**
 * @enum FileGasProjectTypeAdmin
 */
let FileGasProjectTypeAdmin
;(function (fileGasProjectTypeAdmin) {
  fileGasProjectTypeAdmin.None = 0
  fileGasProjectTypeAdmin[0] = "None"
  fileGasProjectTypeAdmin.IdCard = 1
  fileGasProjectTypeAdmin[1] = "IdCard"
  fileGasProjectTypeAdmin.FirstPlan = 2
  fileGasProjectTypeAdmin[2] = "FirstPlan"
  fileGasProjectTypeAdmin.DesignPlan = 11
  fileGasProjectTypeAdmin[11] = "DesignPlan"
  fileGasProjectTypeAdmin.MapFront = 3
  fileGasProjectTypeAdmin[3] = "MapFront"
  fileGasProjectTypeAdmin.BackFront = 4
  fileGasProjectTypeAdmin[4] = "BackFront"
  fileGasProjectTypeAdmin.MapFrontAssign = 5
  fileGasProjectTypeAdmin[5] = "MapFrontAssign"
  fileGasProjectTypeAdmin.BackFrontAssign = 6
  fileGasProjectTypeAdmin[6] = "BackFrontAssign"
  fileGasProjectTypeAdmin.Consent = 7
  fileGasProjectTypeAdmin[7] = "Consent"
  fileGasProjectTypeAdmin.RelatedPermit = 8
  fileGasProjectTypeAdmin[8] = "RelatedPermit"
  fileGasProjectTypeAdmin.EstimationSheet = 9
  fileGasProjectTypeAdmin[9] = "EstimationSheet"
  fileGasProjectTypeAdmin.DraftSheet = 10
  fileGasProjectTypeAdmin[10] = "DraftSheet"
  fileGasProjectTypeAdmin.SampleDesignForm = 12
  fileGasProjectTypeAdmin[12] = "SampleDesignForm"
  fileGasProjectTypeAdmin.ApprovedPostalCode = 14
  fileGasProjectTypeAdmin[14] = "ApprovedPostalCode"
})(FileGasProjectTypeAdmin || (FileGasProjectTypeAdmin = {}))

export { FileGasProjectTypeAdmin }
